import {create} from 'zustand';
import {PublicFlowStore} from './types';
import {DEFAULT_STEPS} from './constants';

export const usePublicFlowStore = create<PublicFlowStore>(set => ({
	steps: {...DEFAULT_STEPS},
	setStep: (flow, value) =>
		set(state => {
			const prev = state.steps[flow];
			const next = typeof value === 'function' ? value(prev) : value;

			return {
				steps: {
					...state.steps,
					[flow]: next,
				},
			};
		}),
	resetStep: flow =>
		set(state => ({
			steps: {...state.steps, [flow]: DEFAULT_STEPS[flow]},
		})),
}));
